import { saveAs } from 'file-saver';
import React, { useEffect, useState } from 'react';
import { Icon, IconButton, Menu, MenuItem } from '@material-ui/core';
import { ConfirmDialog } from '@sierralabs/core-ui';
import { useEntityContext } from '../../EntityContext';
import { useDeleteEntity } from '../../hooks/useDeleteEntity';
const EntityMenuButton = ({ entity, includeDeleted }) => {
    const { getEntities, setSelectedEntity, selectedEntity } = useEntityContext();
    const { deletedEntity, deleteEntity } = useDeleteEntity(entity.id);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [entityMenuAnchor, setEntityMenuAnchor] = useState(null);
    // refresh entities llist when an entity is deleted/undeleted
    useEffect(() => {
        if (deletedEntity) {
            getEntities(true, includeDeleted);
            setEntityMenuAnchor(null);
        }
    }, [deletedEntity, includeDeleted, getEntities]);
    // unselect an entity after it is deleted
    useEffect(() => {
        if (!includeDeleted &&
            deletedEntity &&
            !(deletedEntity === null || deletedEntity === void 0 ? void 0 : deletedEntity.deleted) &&
            (selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.id) === deletedEntity.id) {
            setSelectedEntity(undefined);
        }
    }, [includeDeleted, selectedEntity, deletedEntity, setSelectedEntity]);
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { size: 'small', onClick: event => {
                event.preventDefault();
                setEntityMenuAnchor(event.currentTarget);
            } },
            React.createElement(Icon, { className: 'more-icon' }, "more_vert")),
        entityMenuAnchor && (React.createElement(Menu, { id: 'entity-more-menu', anchorEl: entityMenuAnchor, keepMounted: true, getContentAnchorEl: null, open: Boolean(entityMenuAnchor), anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setEntityMenuAnchor(null) },
            React.createElement(MenuItem, { onClick: () => {
                    setEntityMenuAnchor(null);
                    const exportEntity = Object.assign({}, entity);
                    delete exportEntity.deleted; // make sure deleted flag isn't exported
                    const blob = new Blob([JSON.stringify(exportEntity, undefined, 2)], {
                        type: 'application/json'
                    });
                    saveAs(blob, `${entity.name} Entity.json`);
                } }, "Export Entity"),
            React.createElement(MenuItem, { onClick: () => {
                    setEntityMenuAnchor(null);
                    // undelete an entity by calling deleteEntity() to toggle the
                    // deleted flag.
                    entity.deleted ? deleteEntity() : setOpenConfirmDialog(true);
                } }, entity.deleted ? 'Undelete Entity' : 'Delete Entity'))),
        openConfirmDialog && (React.createElement(ConfirmDialog, { open: openConfirmDialog, title: 'Delete Entity', message: `Are you sure you want to delete the "${entity.displayName}" entity? `, confirmLabel: 'Delete', onCancel: () => setOpenConfirmDialog(false), onConfirm: () => {
                setOpenConfirmDialog(false);
                deleteEntity();
            } }))));
};
export default EntityMenuButton;
//# sourceMappingURL=EntityMenuButton.js.map